import React from "react";
import img from "../../Images/q1.png";
import img2 from "../../Images/q2.png";
import img1 from "../../Images/q3.png";
import { Link } from "react-router-dom";
export default function Index() {
  return (
    <div className=" text-center ">
      <div className="w-11/12 m-auto flex flex-col md:flex-row flex-wrap justify-around items-center p-7 ">
        <div className="flex bg-primary flex-col flex-wrap p-2 w-10/12 md:w-3/12  mx-1 mb-5 justify-between items-center rounded-lg">
          <img src={img} alt="" className="md:w-5/12 " />

          <div className="bg-white flex flex-col flex-wrap h-full w-full md:w-11/12 m-auto rounded-lg justify-center items-center  md:p-2">
            <br />
            <p className="text-xl decoration-8 font-bold m-1">
              The Actualize 4 Languages Assessment
            </p>
            <p className="text-md m-1 font-medium">
              Discover your unique make-up. Actualize your life by discovering
              your Actualize Language for personal and leadership development.
            </p>
            <Link to="/actualize-languages-assessment">
              <button className="p-3 m-1  text-white capitalize font-bold text-start custom-btn-transistion-primary">
                START THE QUIZ!
              </button>
            </Link>

            <br />
          </div>
        </div>
        <div className="flex bg-secondary flex-col flex-wrap p-2 w-10/12 md:w-3/12  mb-5 justify-between items-center rounded-lg">
          <img src={img2} alt="" className="md:w-6/12 " />

          <div className="bg-white flex flex-col flex-wrap h-full w-full md:w-11/12 m-auto rounded-lg justify-center items-center  md:p-2">
            <br />
            <p className="text-xl decoration-8 font-bold m-1">
              Actualize Leadership Assessment
            </p>
            <p className="text-md m-1 font-medium">
              Discover your leadership level by taking the leadership
              assessment.
            </p>
            <Link to="/actualize-leadership-assessment">
              <button className="p-3 m-1   text-white capitalize font-bold custom-btn-transistion">
                START THE QUIZ!
              </button>
            </Link>

            <br />
          </div>
        </div>
        <div className="flex bg-purple flex-col flex-wrap p-2 w-10/12 md:w-3/12  mb-5 justify-between items-center rounded-lg">
          <img src={img1} alt="" className="md:w-6/12 " />

          <div className="bg-white flex flex-col flex-wrap h-full w-full md:w-11/12 m-auto rounded-lg justify-center items-center  md:p-2">
            <br />
            <p className="text-xl decoration-8 font-bold m-1">
              Actualize Purpose Assessment
            </p>
            <p className="text-md m-1 font-medium">
              Discover your level of purpose by taking the actualized purpose
              assessment.
            </p>
            <Link to="/actualize-purpose-assessment">
              <button className="p-3 m-1 text-white capitalize font-bold custom-btn-transistion-purple">
                START THE QUIZ!
              </button>
            </Link>

            <br />
          </div>
        </div>
      </div>
    </div>
  );
}
